var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpendControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 37.9417L21.4674 42.7309C22.575 43.1376 23.7474 43.3458 24.9292 43.3458H38.3696C40.2505 43.3458 42.0926 42.8185 43.6814 41.8253L60.5101 31.3047C61.6204 30.332 61.8262 28.6973 60.9908 27.4863C60.0769 26.1611 58.565 25.9308 56.9014 26.7069L40.517 33.8243L40.5364 31.2017C40.3194 29.0491 38.6395 27.3215 36.4684 27.0184L26.4909 25.885C24.1893 25.5637 23.0391 24.8027 21.0326 23.6447C18.2933 22.0637 15.1767 21.2305 12.0031 21.2305H8.42578V37.9417Z",
    fill: "#ADC0FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 39.7312L21.4674 45.2867C22.575 45.7585 23.7474 46 24.9292 46H38.3696C40.2505 46 42.0926 45.3883 43.6814 44.2362L60.5101 32.0323C61.6204 30.904 61.8262 29.0078 60.9908 27.6029C60.0769 26.0658 58.565 25.7985 56.9014 26.6989L40.517 34.955L40.5364 31.9128C40.3194 29.4158 38.6395 27.4118 36.4684 27.0601L26.4909 25.7455C24.1893 25.3728 23.0391 24.49 21.0326 23.1467C18.2933 21.3128 15.1767 20.3462 12.0031 20.3462H8.42578V39.7312Z",
    fill: "url(#paint0_linear_2375_4063)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.6099 27.7305L39.6094 27.797L39.6516 27.7777C39.6381 27.7616 39.6238 27.7462 39.6099 27.7305Z",
    fill: "#F5DBCC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5549 40.3575C11.5549 41.3395 10.7885 42.1356 9.84314 42.1356H5.7118C4.76643 42.1356 4 41.3395 4 40.3575V18.5857C4 17.6037 4.76643 16.8076 5.7118 16.8076H9.84314C10.7885 16.8076 11.5549 17.6037 11.5549 18.5857V40.3575Z",
    fill: "url(#paint1_linear_2375_4063)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2844 4.42185C41.1224 3.73548 39.8578 3.20496 38.517 2.8617V1.32832C38.517 0.597229 37.9182 0 37.1853 0H32.7251C31.9922 0 31.3934 0.597229 31.3934 1.32832V2.8617C30.0526 3.20496 28.7879 3.73533 27.626 4.42185L26.54 3.33418C26.0216 2.81712 25.1725 2.81712 24.6541 3.33418L21.499 6.47677C20.9806 6.99832 20.9806 7.84069 21.499 8.3579L22.5895 9.44556C21.9013 10.6046 21.3694 11.866 21.0253 13.2032H19.488C18.7551 13.2032 18.1562 13.8006 18.1562 14.5315V18.98C18.1562 19.7111 18.7551 20.3083 19.488 20.3083H21.0253C21.3694 21.6456 21.9012 22.907 22.5895 24.0659L21.499 25.1491C20.9806 25.6661 20.9806 26.513 21.499 27.03L24.6541 30.177C25.1725 30.694 26.0216 30.694 26.54 30.177L27.626 29.0893C28.788 29.7758 30.0526 30.3062 31.3934 30.6495V32.1828C31.3934 32.9139 31.9922 33.5112 32.7251 33.5112H37.1853C37.9182 33.5112 38.517 32.9139 38.517 32.1828V30.6495C39.8578 30.3062 41.1225 29.7758 42.2844 29.0893L43.3704 30.177C43.8888 30.694 44.7379 30.694 45.2563 30.177L48.4114 27.03C48.9299 26.513 48.9299 25.6661 48.4114 25.1491L47.3209 24.0659C48.0091 22.9069 48.541 21.6454 48.8851 20.3083H50.4225C51.1554 20.3083 51.7543 19.7111 51.7543 18.98V14.5315C51.7543 13.8004 51.1554 13.2032 50.4225 13.2032H48.8851C48.541 11.8659 48.0093 10.6044 47.3209 9.44556L48.4114 8.3579C48.9299 7.84084 48.9299 6.99832 48.4114 6.47677L45.2563 3.33418C44.7379 2.81712 43.8888 2.81712 43.3704 3.33418L42.2844 4.42185Z",
    fill: "url(#paint2_linear_2375_4063)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.9479 25.6106C39.8379 25.6106 43.802 21.6465 43.802 16.7565C43.802 11.8665 39.8379 7.90234 34.9479 7.90234C30.0579 7.90234 26.0938 11.8665 26.0938 16.7565C26.0938 21.6465 30.0579 25.6106 34.9479 25.6106Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9485 27.4039C40.8291 27.4039 45.5963 22.6367 45.5963 16.7562C45.5963 10.8756 40.8291 6.1084 34.9485 6.1084C29.0679 6.1084 24.3008 10.8756 24.3008 16.7562C24.3008 22.6367 29.0679 27.4039 34.9485 27.4039Z",
    fill: "url(#paint3_linear_2375_4063)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2375_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.89 18.927C35.89 18.6265 35.8178 18.3941 35.6696 18.2218C35.5213 18.0495 35.2608 17.8892 34.8922 17.7369C34.5195 17.5846 34.1789 17.4324 33.8624 17.2761C33.5458 17.1198 33.2773 16.9395 33.0489 16.7351C32.8205 16.5308 32.6482 16.2944 32.524 16.0259C32.4038 15.7574 32.3437 15.4288 32.3437 15.0482C32.3437 14.407 32.5601 13.8781 32.9928 13.4654C33.4256 13.0527 34.0026 12.8082 34.7199 12.7401V11.542H35.6255V12.7641C36.3187 12.8683 36.8637 13.1528 37.2604 13.6217C37.6571 14.0905 37.8534 14.6835 37.8534 15.4048H35.93C35.93 15.0121 35.8539 14.7076 35.7016 14.4952C35.5494 14.2828 35.333 14.1786 35.0525 14.1786C34.804 14.1786 34.6077 14.2588 34.4715 14.4151C34.3352 14.5713 34.2631 14.7877 34.2631 15.0642C34.2631 15.3407 34.3432 15.5691 34.5035 15.7334C34.6638 15.8977 34.9202 16.0539 35.2689 16.2062C35.6215 16.3545 35.9541 16.5108 36.2666 16.671C36.5792 16.8313 36.8476 17.0156 37.076 17.22C37.3044 17.4244 37.4808 17.6648 37.609 17.9373C37.7372 18.2097 37.8013 18.5383 37.8013 18.919C37.8013 19.5681 37.597 20.0971 37.1842 20.5058C36.7715 20.9145 36.2145 21.1549 35.5053 21.2231V22.3611H34.5997V21.211C33.7742 21.1229 33.1411 20.8424 32.6963 20.3615C32.2555 19.8807 32.0352 19.2516 32.0352 18.4662H33.9505C33.9505 18.899 34.0467 19.2275 34.239 19.4519C34.4314 19.6763 34.7039 19.7885 35.0565 19.7885C35.3129 19.7885 35.5173 19.7124 35.6656 19.5561C35.8138 19.3998 35.89 19.1955 35.89 18.927Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2375_4063",
    x: 0,
    y: 0,
    width: 65.5039,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.568675 0 0 0 0 0.988235 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_4063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_4063",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2375_4063",
    x: 8.42578,
    y: 20.3462,
    width: 57.2781,
    height: 26.6538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.388235 0 0 0 0 0.835294 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_4063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2375_4063",
    x: 4,
    y: 16.8076,
    width: 7.55469,
    height: 26.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_4063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2375_4063",
    x: 18.1562,
    y: 0,
    width: 33.5977,
    height: 34.5112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_4063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2375_4063",
    x: 20.6501,
    y: 6.1084,
    width: 28.5982,
    height: 28.5968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_4063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_4063",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2375_4063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2375_4063",
    x: 31.1718,
    y: 11.1103,
    width: 7.54312,
    height: 12.5456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.431678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.431678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_4063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_4063",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_4063",
    x1: 61.2223,
    y1: 32.3422,
    x2: -14.7432,
    y2: 48.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2375_4063",
    x1: 9.94101,
    y1: 17.4729,
    x2: 0.449446,
    y2: 18.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2375_4063",
    x1: 44.5769,
    y1: 0.880179,
    x2: 20.0156,
    y2: 14.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2375_4063",
    x1: 41.047,
    y1: 6.66773,
    x2: 19.9095,
    y2: 16.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendControlIcon);
export default __webpack_public_path__ + "static/media/spendControlIcon.29585fbc9aa237aacfdae2767941d80b.svg";
export { ForwardRef as ReactComponent };